export { default } from './MoreCircleOutline'
